
import { UblS3UploadedFile } from "@/plugins/ubl/models/ubl-archive-file";
import { UblService } from "@/plugins/ubl/services/ubl-service";
import AppTimeago from "@/components/common/Timeago.vue";
import { printLocalDate, printLocalDateTime } from "@/utils/pretty-print";
import Vue from "vue";
import { copyToClipboard } from "@/utils/clipboard";
import AppCreateUblArchiveModal from "@/components/settings-default/CreateUblArchiveModal.vue";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
import AppCreateUblArchiveModalCreated from "@/components/settings-default/CreateUblArchiveModalCreated.vue";
import {ISelectItem} from "winfakt-vue-components";


export default Vue.extend({
	filters: {
		printLocalDate
	},
	data() {
		return {
			archives: [] as UblS3UploadedFile[],
			createArchiveModal: false,
			sendArchiveModal: false,
			createPurchaseArchive: false,
			vatPeriod: null,
			toSendArchive: null as UblS3UploadedFile | null,
		};
	},
	props: {
		closable: Boolean,
		dossierName: {
			type: String,
			default: ""
		}
	},
	computed: {
		cardTitle():string {
			if (this.dossierName) {
				return `Dossier verzenden aan boekhouder — ${this.dossierName}`;
			}
			return "Dossier verzenden aan boekhouder";
		},
		hasBookkeeping(){
			return AuthService.hasModule(MODULE.BOEKHOUDLIJSTEN) || AuthService.hasModule(MODULE.EXPORT_NAAR_EXTERN_BOEKHPAKKET);
		},
		dropdownItems():ISelectItem<Function>[]{
			let items:ISelectItem<Function>[] = [
				{
					text: this.$ct("add-sale-archive"),
					value: this.addSaleArchive
				},
				{
					text: this.$ct("add-purchase-archive"),
					value: this.addPurchaseArchive
				}
			];
			return items;
		}
	},
	methods: {
		async getArchives() {
			this.archives = await UblService.getArchives();
		},
		addSaleArchive(){
			this.createPurchaseArchive=false;
			this.createArchiveModal=true;
		},
		addPurchaseArchive(){
			this.createPurchaseArchive=true;
			this.createArchiveModal=true;
		},
		printLocalDateTime,
		shortDate(date:Date):string {
			return date.toLocaleDateString("nl-be", {day: "numeric", month: "short", year: "numeric"});
		},
		sentTooltip(archive:UblS3UploadedFile):string {
			let result = printLocalDateTime(archive.SentAt);
			if (archive.SentTo) {
				result += ` · ${archive.SentTo}`;
			}
			return result;
		},
		async downloadUblArchive(archive:UblS3UploadedFile){
			await UblService.downloadArchive(archive);
			await this.getArchives();
		},
		async sendUblArchive(id:number){
			try{
				this.toSendArchive = await UblService.getArchive(id);
				this.sendArchiveModal = true;
			}catch(err){

			}
		},
		copyUblArchiveLink(archive:UblS3UploadedFile) {
			let link = archive.getPublicLink();
			copyToClipboard(link);
			this.$wf.notify(this.$ct("public-link-copied"), "success", 3000, "check");
		}
	},
	async created() {
		await this.getArchives();
	},
	components: {
		AppTimeago,
		AppCreateUblArchiveModal,
		AppCreateUblArchiveModalCreated
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
